import axios from 'axios';

// P1 Görev Paketi E — harici 360° değerlendirici public API istemcisi.
// Anonim istemci: interceptor YOK, cookie YOK — URL'deki 64-hex token tek
// yetkidir (services/publicOfferService.js deseninin birebir kopyası; dosya
// sahiplik sınırı gereği services/ yerine bu sayfa klasöründe).
const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5148',
  timeout: 30000,
});

export const getPublicFeedbackForm = (token) =>
  publicApi.get(`/v1/public/feedback/${encodeURIComponent(token)}`);

// payload: { answers: [{ questionId, likertValue?, textValue? }] } —
// overallLevel BİLEREK gönderilmez (harici için sunucu tarafında HER ZAMAN yasak).
export const submitPublicFeedback = (token, payload) =>
  publicApi.post(`/v1/public/feedback/${encodeURIComponent(token)}`, payload);
